// Lista centralizada de unidades de negocio.
// Cualquier pantalla que necesite la lista de unidades debe importarla de aquí,
// en vez de tener su propia copia. Así, agregar/renombrar una unidad se hace
// en un solo lugar.

export const UNIDADES = [
  { id: "aguilas",       nombre: "Sushiito Águilas",     nombreCorto: "Águilas",       grupo: "sushiito", color: "#C8A96E", usaCargaXML: true },
  { id: "punta_norte",   nombre: "Sushiito Punta Norte", nombreCorto: "Punta Norte",   grupo: "sushiito", color: "#5B9BAF", usaCargaXML: true },
  // grupoAdicionalXML: aunque Society es su propio grupo, sus facturas suelen venir
  // mezcladas en los mismos XML que Águilas/Punta Norte, así que también aparece
  // como opción de Tienda al cargar XML con la empresa "sushiito" activa.
  { id: "antara",        nombre: "Society",              nombreCorto: "Society",       grupo: "society",  color: "#AF5B5B", usaCargaXML: false, grupoAdicionalXML: "sushiito" },
  { id: "urban_polanco", nombre: "Urban Polanco",        nombreCorto: "Urban Polanco", grupo: "urban",    color: "#5aaa5a", usaCargaXML: false },
  { id: "urban_zr",      nombre: "Urban Zona Rosa",      nombreCorto: "Urban ZR",      grupo: "urban",    color: "#c9784a", usaCargaXML: false },
  { id: "urban_comisariato", nombre: "Urban Comisariato", nombreCorto: "Comisariato",  grupo: "urban",    color: "#8a6ab0", usaCargaXML: false }
];

export const GRUPOS = [
  { id: "sushiito", nombre: "Sushiito", icono: "🍣" },
  { id: "society",  nombre: "Society",  icono: "🍽️" },
  { id: "urban",    nombre: "Urban",    icono: "🏢" }
];

// Devuelve solo las unidades del grupo indicado. Si no se pasa grupo, regresa todas.
export function unidadesDeGrupo(grupo) {
  if (!grupo) return UNIDADES;
  return UNIDADES.filter(u => u.grupo === grupo);
}

export function nombreDeUnidad(id) {
  return UNIDADES.find(u => u.id === id)?.nombre || id;
}

export function grupoDeUnidad(id) {
  return UNIDADES.find(u => u.id === id)?.grupo || null;
}
